const CABLE_RULES = [
  { match: type => type?.startsWith('SDI') || type === 'MADI-BNC' || type?.startsWith('BNC'), id: 'bnc', label: 'BNC / koncentryczny' },
  { match: type => type === 'HDMI', id: 'hdmi', label: 'HDMI' },
  { match: type => type === 'DisplayPort', id: 'displayport', label: 'DisplayPort' },
  { match: type => type === 'XLR' || type === 'AES-EBU', id: 'xlr', label: 'XLR' },
  { match: type => ['Jack', 'TRS', 'TRRS'].includes(type), id: 'jack', label: 'Jack 6.35 mm' },
  { match: type => ['RJ45', 'Ethernet', 'Dante', 'AES50', 'NDI', 'HDBaseT'].includes(type), id: 'ethernet', label: 'Ethernet / RJ45' },
  { match: type => ['USB-C', 'USB-C-DATA', 'USB-C-PD', 'Thunderbolt'].includes(type), id: 'usb-c', label: 'USB-C' },
  { match: type => ['USB-A', 'USB-B', 'USB', 'USB-Micro-B'].includes(type), id: 'usb', label: 'USB' },
  { match: type => ['Mini-Jack', 'Mini-Jack-2.5'].includes(type), id: 'mini-jack', label: 'Mini-jack' },
  { match: type => ['IEC-C13', 'IEC-C14'].includes(type), id: 'iec-c13', label: 'IEC C13/C14' },
  { match: type => ['IEC-C19', 'IEC-C20'].includes(type), id: 'iec-c19', label: 'IEC C19/C20' },
  { match: type => ['PowerCON', 'PowerCon', 'TRUE1', 'powerCON TRUE1'].includes(type), id: 'powercon', label: 'PowerCON / TRUE1' },
  { match: type => ['Schuko', '230V'].includes(type), id: 'schuko', label: 'Schuko 230 V' },
  { match: type => type?.startsWith('DC-'), id: 'dc', label: 'Zasilanie DC' },
];

export function getRequiredCable(typeA, typeB) {
  const rule = CABLE_RULES.find(item => item.match(typeA) || item.match(typeB));
  if (rule) return { id: rule.id, label: rule.label, ends: [typeA, typeB] };
  return { id: String(typeA || typeB || 'inne').toLowerCase(), label: typeA || typeB || 'Inny przewód', ends: [typeA, typeB] };
}

export function summarizeCableNeeds(links = [], nodes = []) {
  return links.reduce((summary, link) => {
    const fromNode = nodes.find(node => node.instanceId === link.fromNode);
    const toNode = nodes.find(node => node.instanceId === link.toNode);
    const fromPort = fromNode?.outputs?.find(port => port.id === link.fromPort);
    const toPort = toNode?.inputs?.find(port => port.id === link.toPort);
    const cable = getRequiredCable(fromPort?.type, toPort?.type);
    const current = summary[cable.label] || { total: 0, needed: 0 };
    current.total += 1;
    if (link.cableStatus !== 'available') current.needed += 1;
    summary[cable.label] = current;
    return summary;
  }, {});
}
